import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import app from '../client/app';
/**
 * Authenticate user
 */

export function authenticate() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        var token, payload, user;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return app.authenticate();

              case 3:
                token = _context.sent;
                _context.next = 6;
                return app.passport.verifyJWT(token.accessToken);

              case 6:
                payload = _context.sent;
                _context.next = 9;
                return dispatch(getUser(payload.userId));

              case 9:
                user = _context.sent;
                dispatch({
                  type: 'USER_IS_LOGGED_IN',
                  user: user
                });
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0); // delete token and cookie

                app.logout();
                dispatch({
                  type: 'USER_IS_ANONYMOUS'
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Logout user
 */

export function logout() {
  return function (dispatch) {
    app.logout();
    dispatch({
      type: 'USER_IS_ANONYMOUS'
    });
  };
}
/**
 * Get a fully-loaded user object, including the groups and locations the user belongs to.
 *
 * @param {number} userId The user id
 * @return {object} The user object
 */

export function getUser(userId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch) {
        var user, ids, _ref3, _ref3$data, groups, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, group, _ref4, _ref4$data, locations;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return app.service('user').get(userId);

              case 2:
                user = _context2.sent;
                // get user groups
                ids = user.memberships.map(function (membership) {
                  return membership.group;
                });
                _context2.next = 6;
                return app.service('group').find({
                  query: {
                    _id: {
                      $in: ids
                    }
                  }
                });

              case 6:
                _ref3 = _context2.sent;
                _ref3$data = _ref3.data;
                groups = _ref3$data === void 0 ? [] : _ref3$data;
                user.groups = groups; // get user locations

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 13;
                _iterator = groups[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 26;
                  break;
                }

                group = _step.value;
                _context2.next = 19;
                return app.service('location').find({
                  query: {
                    group: group._id
                  }
                });

              case 19:
                _ref4 = _context2.sent;
                _ref4$data = _ref4.data;
                locations = _ref4$data === void 0 ? [] : _ref4$data;
                group.locations = locations;

              case 23:
                _iteratorNormalCompletion = true;
                _context2.next = 15;
                break;

              case 26:
                _context2.next = 32;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 32:
                _context2.prev = 32;
                _context2.prev = 33;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 35:
                _context2.prev = 35;

                if (!_didIteratorError) {
                  _context2.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context2.finish(35);

              case 39:
                return _context2.finish(32);

              case 40:
                return _context2.abrupt("return", user);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[13, 28, 32, 40], [33,, 35, 39]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * Trigger snackbar notification
 */

export function showSnack(message, action) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: 'NEW_MESSAGE',
                  message: message,
                  action: action
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}
/**
 * Dismiss snackbar
 */

export function dismissSnack() {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: 'DISMISS_MESSAGE'
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}